module.exports = __webpack_public_path__ + "static/img/onozuka_01.14201b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/onozuka_01.jpg
// module id = p8fA
// module chunks = 0